import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import animateScrollTo from 'animated-scroll-to';

const PaginationComponent = ({
    currentPage,
    totalPages,
    onPageChange,
    handleNext,
    handlePrev,
    isMobile,
    listRef,
}) => {
    const createPageList = () => {
        const pages = [];
        const range = 3;

        // eslint-disable-next-line no-plusplus
        for (let i = Math.max(1, currentPage - range); i <= Math.min(totalPages, currentPage + range); i++) {
            pages.push(i);
        }

        if (pages[0] > 1) pages.unshift('...');

        if (pages[pages.length - 1] < totalPages) pages.push('...');

        return pages;
    };

    const scrollToList = () => {
        if (listRef?.current) {
            animateScrollTo(listRef.current, { speed: 700 });
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);

            handlePrev();

            scrollToList();
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);

            handleNext();

            scrollToList();
        }
    };

    const handlePageClick = (pageNumber) => {
        if (pageNumber !== currentPage && pageNumber !== '...') {
            onPageChange(pageNumber);

            scrollToList();
        }
    };

    return (
        <div className="container-pagination tw-flex tw-justify-between tw-items-center tw-mt-8">
            <button
                type="button"
                className={`prev-pagination tw-cursor-pointer tw-flex tw-items-center ${currentPage === 1 ? 'tw-text-gray-400' : 'tw-text-black'}`}
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
                aria-disabled={currentPage === 1}
            >
                <FontAwesomeIcon icon={faArrowLeft} width={16} className="tw-mr-2" />
                <span className={`${isMobile ? 'tw-hidden' : 'tw-block'}`}>Anterior</span>
            </button>

            <ul className="tw-flex tw-mb-0">
                {createPageList().map((pageNumber, index) => (
                    <li
                        key={index}
                        className={`tw-w-10 tw-h-10 tw-p-2 tw-mx-1 tw-cursor-pointer ${pageNumber === currentPage ? 'tw-bg-slate-100  tw-text-black' : 'tw-bg-transparent tw-text-black'}`}
                    >
                        <button
                            type="button"
                            className="tw-w-full tw-h-full tw-p-0"
                            onClick={() => handlePageClick(pageNumber)}
                            aria-label={`Página ${pageNumber}`}
                            disabled={pageNumber === '...'}
                        >
                            {pageNumber}
                        </button>
                    </li>
                ))}
            </ul>

            <button
                type="button"
                className={`next-pagination tw-cursor-pointer tw-flex tw-items-center ${currentPage === totalPages ? 'tw-text-gray-400' : 'tw-text-black'}`}
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
                aria-disabled={currentPage === totalPages}
            >
                <span className={`${isMobile ? 'tw-hidden' : 'tw-flex'}`}>Próximo</span>
                <FontAwesomeIcon icon={faArrowRight} width={16} className="tw-ml-2" />
            </button>
        </div>
    );
};

PaginationComponent.propTypes = exact({
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
    onPageChange: PropTypes.func,
    handleNext: PropTypes.func,
    handlePrev: PropTypes.func,
    isMobile: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    listRef: PropTypes.func,
});

export default PaginationComponent;
